import Cookies from "js-cookie";
import params from "./getParams";

//获取用户登录信息
export const getCookie = (key) => {
  let value = "";
  try {
    value = params[key] ? params[key] : window.cookie_list[key] || "";
  } catch { }
  return value;
};